import { ReactNode, useMemo, useState } from "react";

import { CustomTabContext, useCustomTab } from "./CustomTabContext";

type RootProps = {
  children: ReactNode;
  initialTab?: number;
};

const Root = ({ children, initialTab = 0 }: RootProps) => {
  const [tab, setTab] = useState(initialTab);

  const value = useMemo(() => {
    return {
      tab,
      setTab,
    };
  }, [tab, setTab]);

  return (
    <CustomTabContext.Provider value={value}>
      {children}
    </CustomTabContext.Provider>
  );
};

type ContentProps = { children: ReactNode; tab: number };

const Content = ({ children, tab }: ContentProps) => {
  const { tab: currentTab } = useCustomTab();

  if (currentTab !== tab) {
    return null;
  }

  return children;
};

export { Root as CustomTab, Content as CustomTabContent };
